export default __webpack_public_path__ + "static/media/iconmonstr-menu-11.aea5024f.svg";